import { createOnetimePasswordApi } from './graphql/createOnetimePassword';

export const types = {
  SET_ONETIME_PASSWORD: 'requestMobilePassword/SET_ONETIME_PASSWORD',
};

export const setOnetimePassword = (password) => {
  return {
    type: types.SET_ONETIME_PASSWORD,
    password,
  };
};

export const requestOnetimePassword = (phoneNumber) => {
  return async (dispatch, getState, { client }) => {
    const strippedPhoneNumber = phoneNumber.replace(/[-() *]/g, '');
    const formattedPhoneNumber = `+1${strippedPhoneNumber}`;
    const result = await createOnetimePasswordApi(client, formattedPhoneNumber);
    if (result.data) {
      dispatch(setOnetimePassword(result.data.user_onetime_password));
    }
  };
};
